import { configureStore } from "@reduxjs/toolkit";
import GeneralSlice from "../General/Store/GeneralSlice";
import saleReducer from "../scenes/Qualitycontrol/SaleSlice/SaleSlice";
import orderReducer from "../scenes/Orders/OrderSlice/OrderSlice";
import DesignerSlice from "../scenes/Designer/DesignerSlice/DesignerSlice";
import OrderOnlineSlice from "../scenes/OnlineOrder/OrderOnlineSlice/OrderOnlineSlice";
import ChartSlice from "../scenes/Organization/Chart/ChartSlice/ChartSlice";
import UserSlice from "../scenes/OrganizationDefinitions/CreateUserAccount/Components/userSlice/UserSlice";
import LaserSlice from "../scenes/Production/Laser/LaserSlice/LaserSlice";
import loggingMiddleware from "../middleware";
import ReportListSlice from "../scenes/Reports/ReportList/ReportListSlice/ReportListSlice";
import TreeDrowpSlice from "../General/Components/TreeToDrowp/Slice/TreeDrowpSlice";
import PersonCartableSlice from "../scenes/PersonFroms/slice/PersonCartableSlice";
const store = configureStore({
  reducer: {
    general: GeneralSlice,
    sale: saleReducer,
    order: orderReducer,
    designer: DesignerSlice,
    orderOnline: OrderOnlineSlice,
    chart: ChartSlice,
    addPersonInfo: UserSlice,
    laser: LaserSlice,
    reportList: ReportListSlice,
    treeDrowp: TreeDrowpSlice,
    personCartable:PersonCartableSlice
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
      
    })
});
export default store;
